// 關於我們下方的圖片輪播
module.exports = [
  {
    src: require('../assets/slides_photo/photo-01.jpg'),
    alt: 'photo-01.jpg',
  },
  {
    src: require('../assets/slides_photo/photo-02.jpg'),
    alt: 'photo-02.jpg',
  },
  {
    src: require('../assets/slides_photo/photo-03.jpg'),
    alt: 'photo-03.jpg',
  },
  {
    src: require('../assets/slides_photo/photo-04.jpg'),
    alt: 'photo-04.jpg',
  },
  {
    src: require('../assets/slides_photo/photo-01.jpg'),
    alt: 'photo-01.jpg',
  },
  {
    src: require('../assets/slides_photo/photo-02.jpg'),
    alt: 'photo-02.jpg',
  },
  {
    src: require('../assets/slides_photo/photo-03.jpg'),
    alt: 'photo-03.jpg',
  },
  {
    src: require('../assets/slides_photo/photo-04.jpg'),
    alt: 'photo-04.jpg',
  },
  // {
  //   src: require(''),
  //   alt: '',
  // },
]



// WEBPACK FOOTER //
// ./src/plugins/about_slider.js